// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export { default as StickyScrollbar } from './sticky-scrollbar';



// WEBPACK FOOTER //
// /local/p4clients/src/table/sticky-scrollbar/index.tsx